<template>
  <div>
    <div class="social-accounts-panel">
        <h2 class="panel-title">Link your social account</h2>
        <div class="social-item-container">
          <google-signin-button class="social-item-button" :provider="'google'" action="link"/>
          <rt-picture class="social-item-checked" src="/assets/app/class/pretest_completed_icon.svg" v-if="hasLinkedProvider('GOOGLE')"></rt-picture>
        </div>
        <div class="social-item-container">
          <google-signin-button class="social-item-button" :provider="'microsoft'" action="link"/>
          <rt-picture class="social-item-checked" src="/assets/app/class/pretest_completed_icon.svg" v-if="hasLinkedProvider('MICROSOFT')"></rt-picture>
        </div>
        <div class="social-item-container">
          <google-signin-button class="social-item-button" :provider="'clever'" action="link"/>
          <rt-picture class="social-item-checked" src="/assets/app/class/pretest_completed_icon.svg" v-if="hasLinkedProvider('CLEVER')"></rt-picture>
        </div>
    </div>
    <div class="setting-panel-footer">
      <primary-button class="btn-close" @click="$emit('close')">Close</primary-button>
    </div>
  </div>
</template>

<script>
import GoogleSigninButton from '../../signup/components/GoogleSignupButton.vue';
import RtPicture from '../Picture.vue';
import Utils from '../../../../common/Utils';
import {getAuthToken} from '../../../../common/authtoken';
import PrimaryButton from "../PrimaryButton.vue";
import { getUserSocialProviders } from 'common/api';
export default {
  components: {
    GoogleSigninButton,
    RtPicture,
    PrimaryButton
  },
  data: function() {
    return {
      providers: []
    }

  },
  mounted() {
    Utils.setCookie('currentUserToken', getAuthToken(), 1, );
    getUserSocialProviders().then((res) => {
      this.providers = res.map(p => p['provider'])
    });
  },
  methods: {
    hasLinkedProvider(provider) {
      return this.providers.indexOf(provider) > -1
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../variables';
.social-accounts-panel {
  .panel-title {
    font-family: $title-font;
    font-size: 18px;
    margin-bottom: 1rem;
  }

  .social-item-container {
    display: flex;
    width: 100%;
    height: 43px;
    margin-bottom: 10px;

    .social-item-checked {
      width: 25px;
    }

    .social-item-button {
      width: 295px;
      height: auto;
    }
  }

}
</style>


